module.exports = __webpack_public_path__ + "img/energyImg2.2cc63364.png";